import { useAuthRequired } from "../../state/useAuthRequired";

export function useMyAccount(props: any) {
  useAuthRequired();
}
